// extracted by mini-css-extract-plugin
export default {"footer":"fx75TfRWAuX6jJELPeqq","container":"tFCGcyjf9XK0yXQTiMRw","donate":"ylP1FV65Rtr0kjsmAJYZ"};